const PERMISSION_KEY= "crm:segment_user";
const PAGE_URL = {
    SEGMENT_USER_PAGE: "/admin/crm/segment-user"
}

export {PERMISSION_KEY, PAGE_URL}

